import type { AppState } from "store/types";

export const getCurrentApplication = (state: AppState) => {
  return state.application.wrapper.currentApplication;
};

export const getEnvironment = (state: AppState) =>
  state.application.wrapper.environment;

export const selectCurrentApplicationSignatureTree = (state: AppState) =>
  state.application.wrapper?.currentApplicationSignatureTree;
